<template>
  <el-container>
    <el-header class="pt10 plr0 white-bg">
      <div class="flex al-cn ju-sp type-center">
        <div class="logo" @click="routerGo('/')">
          <img src="@/assets/web/logo.png" alt/>
        </div>
        <div class="searchInput flex al-cn">
          <el-input
              v-model="input"
              placeholder="请输入内容"
              class="search-input"
              @keyup.enter.native="search">
          </el-input>
          <div class="searchInput-icon pointer">
            <i class="el-input__icon el-icon-search" @click="search"></i>
          </div>
        </div>
        <div class="flex al-cn">
          <img class="flag" src="@/assets/web/Chinese.png" @click="imageClick('https://cn.nihaoboss.com')" alt/>
          <img class="flag" src="@/assets/web/Korean.png" @click="imageClick('https://nihaoboss.com')" alt/>
        </div>
      </div>
      <div class="white-bg">
        <div class="type-center">
          <el-menu
              :default-active="defaultActive"
              class="menu-a p0 font-bold"
              mode="horizontal"
              active-text-color="#E03629"
              text-color="#333333"
              @select="handleSelect"
              :router="router">
            <div class="flex" style="overflow: auto;width: 100%">
              <el-menu-item index="/">홈</el-menu-item>
              <el-menu-item index="/enterpriseInformation">해외기업</el-menu-item>
              <el-menu-item index="/Check-inInformation">가이드/기사</el-menu-item>
              <el-menu-item index="/excellentEnterprisePavilion">취급업무</el-menu-item>
            </div>
          </el-menu>
        </div>
      </div>
    </el-header>
    <el-main>
      <div class="type-center">
        <router-view></router-view>
      </div>
    </el-main>
    <div class="footer f14 white-color p0" v-show="isShow">
      <div class="bg253943">
        <div class="flex al-cn war-pe footer-top type-center">
          <div
              class="footer-top-item discolour-blue"
              v-for="(item,index) in articles"
              :key="index"
              @click="routerGo('/exhibitionInformation?id='+item.article_id)">
            <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top-start">
              <div>{{ item.text }}</div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="footer-content type-center ptb20">
<!--        <div class="flex war-pe">-->
<!--          <div class="footer-content-item">客服中心：+86-138-5327-3110</div>-->
<!--          <div class="footer-content-item">邮箱：mangtoo@126.com</div>-->
<!--          <div class="footer-content-item">中国山东省青岛市城阳区春阳路88号112</div>-->
<!--        </div>-->
        <div class="flex war-pe mtb10">
          <div class="footer-content-item">고객센터: +86-138-5327-3110</div>
          <div class="footer-content-item">이메일: mangtoo@126.com</div>
          <div class="footer-content-item">중국 산동성 청도시 성양구 춘양로88호 32동 112</div>
        </div>
        <div class="flex war-pe">
          <div class="footer-content-item">
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
              鲁ICP备16023773号-6
            </a>
          </div>
          <div class="footer-content-item">
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
              鲁公网安备 37021402001427
            </a>
          </div>
          <div class="footer-content-item">Qingdao Mangtoo Networks Technology Co Ltd</div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import {mapState} from 'vuex';

export default {
  data() {
    return {
      router: true,
      //路由激活
      defaultActive: "/",
      home: true,
      isShow: true,
      input: '',
      footerTop: [],
    };
  },
  computed: {
    ...mapState(['token', 'userInfo', 'articles']),
  },
  watch: {
    $route(val) {
      this.defaultActive = val.fullPath;
      this.home = this.defaultActive === '/Home';
    }
  },
  mounted() {
    this.defaultActive = this.$route.fullPath;
    this.home = this.defaultActive === '/Home';
  },
  methods: {
    // 搜索
    imageClick(url) {
      window.location.href = url;
    },
    search() {
      this.$router.push({
        path: "/enterpriseInformation?keyword=" + this.input
      })
    },

    handleSelect(key) {
      this.home = key === '/Home';
    },
    //路由跳转
    routerGo(path) {
      this.$router.push({path: path});
    },
    loginIn() {
      this.$router.push({name: "login"});
    },
  }
};
</script>

<style lang="scss">
.searchInput {
  border-radius: 2px;
  //border: 1px solid #E03629;
  .search-input .el-input__inner {
    border: 1px solid #E03629 !important;
    border-radius: 4px 0 0 4px;
  }

  &-icon {
    text-align: center;
    width: 40px;
    height: 40px;
    background: #E03629;
    border-radius: 0 4px 4px 0;
    color: #fff;
  }
}

.el-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;

  .logo {

    img {
      width: 100%;
      height: 40px;
    }
  }

  .flag {
    width: 32px;
    height: 30px;
    margin-left: 10px;
  }
}

.menu-a {
  //超出时横向滚动
  width: 100%;
  overflow: auto;
}

.el-menu-item.is-active {
  border-bottom: 0 solid #409EFF !important;
}

.el-main {
  padding: 0 !important;
  margin-top: 112px;
}

.footer {
  width: 100%;
  overflow: hidden;
  background-color: #1A2E3A;

  &-top {
    padding-top: 20px;
    padding-bottom: 20px;

    &-item {
      margin-right: 60px;
    }
  }

  &-content {
    //min-height: 240px;

    &-item {
      margin: 0 20px 10px 0;

      a {
        color: #fff;

        &:hover {
          color: #2e4aff;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .el-header {
    .logo {
      img {
        width: 100px;
        height: 18px;
        margin-right: 5px;
      }
    }
  }
  .footer-top {
    padding-top: 10px;
    padding-bottom: 0;

    &-item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  .footer-content {
    //padding: 0 10px;
  }
}

@media (min-width: 750px) {
  .search-input {
    width: 600px;
  }
}
</style>
